import React, { Component } from 'react';
import { MenuItem, Typography, Checkbox, Button, Select, MenuItem as MUIItem, InputBase } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { withStyles } from '@material-ui/styles';

const NoUnderlineInput = withStyles({
    input: {
        '&:before': {
            borderBottom: 'none',
        },
        '&:after': {
            borderBottom: 'none',
        },
    },
})(InputBase);

const CustomCheckbox = withStyles({
    root: {
        color: '#4275ba', // The color when the checkbox is unchecked
        '&$checked': {
            color: '#4275ba', // The color when the checkbox is checked
        },
    },
    checked: {},
})(Checkbox);

const styles = theme => ({
    dropdownContainer: {
        width: '100%',
    },
});

class DraggableDropdown extends Component {
    state = {
        loading: false,
    };

    handleOnDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const newOrder = Array.from(this.props.accordionSections);
        const [movedItem] = newOrder.splice(result.source.index, 1);
        newOrder.splice(result.destination.index, 0, movedItem);

        this.props.onReorder(newOrder);
    };

    handleApply = async () => {
        this.setState({ loading: true });

        try {
            await this.props.onApply();
        } finally {
            this.props.handleMenuClose();
        }
    };

    handleCheckboxChange = (id) => {
        this.props.onToggleVisibility(id); // Toggle section visibility
    };

    handleSelectChange = (id, event) => {
        this.props.onChangeView(id, event.target.value); // Change the accordion view
    };

    render() {
        const { accordionSections } = this.props;
        const { loading } = this.state;

        // Separate notification section from other sections
        const notificationSection = accordionSections.find(section => section.title === "Notification");
        const otherSections = accordionSections.filter(section => section.title !== "Notification");

        return (
            <div style={{ width: "100%" }}>
                {/* Render the Notification section separately */}
                {notificationSection && (
                    <MenuItem style={{ backgroundColor: '#f0f0f0', cursor: 'default' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <CustomCheckbox
                                    checked={notificationSection.visible} // Checkbox for section visibility
                                    onChange={() => this.handleCheckboxChange(notificationSection.id)}
                                />
                                <Typography variant="body1">{notificationSection.title}</Typography>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 43 }}>
                                <Typography variant="subtitle1" style={{ marginRight: '5px' }}>
                                    Default View
                                </Typography>
                                <Select
                                    value={notificationSection.view}
                                    onChange={(event) => this.handleSelectChange(notificationSection.id, event)}
                                    input={<NoUnderlineInput />}
                                    disableUnderline
                                >
                                    <MUIItem value="Expanded">Expanded</MUIItem>
                                    <MUIItem value="Collapsed">Collapsed</MUIItem>
                                </Select>
                            </div>
                        </div>
                    </MenuItem>
                )}
                <DragDropContext onDragEnd={this.handleOnDragEnd} style={{ width: "100%" }}>
                    <Droppable droppableId="dropdown">
                        {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps} style={{ width: "100%" }}>
                                {otherSections.map((section, index) => (
                                    <Draggable key={section.id} draggableId={section.id} index={index}>
                                        {(provided) => (
                                            <MenuItem
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <CustomCheckbox
                                                            checked={section.visible} // Checkbox for section visibility
                                                            onChange={() => this.handleCheckboxChange(section.id)}
                                                        />
                                                        <Typography variant="body1">{section.title}</Typography>
                                                    </div>

                                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 43 }}>
                                                        <Typography variant="subtitle1" style={{ marginRight: '5px' }}>
                                                            Default View
                                                        </Typography>
                                                        <Select
                                                            value={section.view}
                                                            onChange={(event) => this.handleSelectChange(section.id, event)}
                                                            input={<NoUnderlineInput />}
                                                            disableUnderline
                                                        >
                                                            <MUIItem value="Expanded">Expanded</MUIItem>
                                                            <MUIItem value="Collapsed">Collapsed</MUIItem>
                                                        </Select>
                                                    </div>

                                                    <div style={{ position: 'absolute', top: '35%', right: '15px' }}>
                                                        <MenuIcon />
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                <div style={{ textAlign: 'right', padding: '10px' }}>
                    <Button
                        variant="contained"
                        color="default"
                        onClick={this.props.onResetAll}
                        style={{ backgroundColor: '#fff', border: '1px solid #4275ba', color: '#4275ba' }}
                        disabled={loading} // Disable button when loading
                    >
                        Reset All
                    </Button>
                    <Button
                        variant="contained"
                        color="#192b54"
                        onClick={this.handleApply}
                        style={{ marginLeft: '10px', backgroundColor: '#192b54', color: '#fff' }}
                        disabled={loading} // Disable button when loading
                    >
                        Apply
                    </Button>
                </div>
            </div>
        );
    }
}

export default DraggableDropdown;
